import React from 'react';
import { injectIntl, FormattedMessage } from 'react-intl';

import { H, P } from '@xingternal/malt-typography';
import { TextButtonRegularSmall as TextButton } from '@xingternal/malt-button';

import GearImage from './../Illustrations/GearImage';

import styles from './NoScriptFallback.css';
import messages from './messages';

const NoScriptFallback = ({ children, noFallback, intl }) => {
  if (noFallback) return children;

  return (
    <>
      <noscript>
        <div className={styles.center}>
          <GearImage />
          <H>
            <FormattedMessage {...messages.title} />
          </H>
          <P>
            <FormattedMessage {...messages.paragraph} />
          </P>
          <TextButton href={intl.formatMessage(messages.linkTarget)}>
            <FormattedMessage {...messages.linkText} />
          </TextButton>
        </div>
      </noscript>
      <div className={'content'}>{children}</div>
    </>
  );
};

export default injectIntl(NoScriptFallback);
